import { bbox3857 } from './wmsImageMapType';
import { createImgTileMapType, plainPlacement } from './imgTileMapType';

function normaliseCoord(coord, zoom) {
  const n = 2 ** zoom;
  if (coord.y < 0 || coord.y >= n) return null;
  return {
    x: ((coord.x % n) + n) % n,
    y: coord.y,
  };
}

function buildDynamicLayers(layerId, override) {
  const ids = Array.isArray(layerId) ? layerId : [layerId];
  return JSON.stringify(
    ids.map((id) => ({
      id,
      source: { type: 'mapLayer', mapLayerId: id },
      drawingInfo: {
        renderer: {
          type: 'simple',
          symbol: {
            type: 'esriSFS',
            style: 'esriSFSSolid',
            color: override.fillColour,
            outline: {
              type: 'esriSLS',
              style: 'esriSLSSolid',
              color: override.outlineColour,
              width: override.outlineWidth,
            },
          },
        },
      },
    })),
  );
}

export function buildArcgisTileUrl(source, coord, zoom) {
  // Guard against transient bad calls (null coord / non-finite zoom on rapid mobile
  // zoom) that would emit a poisoned bbox=NaN URL. null = "no tile here" (won't wedge).
  if (!coord || typeof zoom !== 'number' || !Number.isFinite(zoom)) return null;

  const wrapped = normaliseCoord(coord, zoom);
  if (!wrapped) return null;

  const layerIdParam = Array.isArray(source.layerId)
    ? source.layerId.join(',')
    : String(source.layerId);

  const params = new URLSearchParams({
    f: 'image',
    format: 'png32',
    transparent: 'true',
    size: '256,256',
    bboxSR: '3857',
    imageSR: '3857',
    layers: `show:${layerIdParam}`,
    bbox: bbox3857(wrapped.x, wrapped.y, zoom),
  });

  if (source.rendererOverride) {
    params.set('dynamicLayers', buildDynamicLayers(source.layerId, source.rendererOverride));
  }

  return `${source.serviceUrl}/export?${params.toString()}`;
}

export function createArcgisImageMapType(source, opacity, onOutcome) {
  // Plain-object MapType rather than ImageMapType: see lib/adapters/imgTileMapType.js.
  // This is the path soil 1:25k is on, and it is the one layer known to be dead,
  // so it is the path that most needs a real tile outcome rather than an
  // assumption that constructing an overlay means it works.
  return createImgTileMapType({
    id: source.id,
    opacity,
    onOutcome,
    resolve: (coord, zoom) => plainPlacement(buildArcgisTileUrl(source, coord, zoom)),
  });
}
